package dev.lingvo.site.pages.app.projects.slug.screenshots

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout

/** Layout and Canvas share the same authority-bound route and versioned design session. */
@Page("/app/projects/{slug}/screenshots/design")
@Layout(".components.layouts.AppLayout")
@Composable
fun ScreenshotDesignPage() { DesignWorkspace() }
